const state = {
    gapMode: null,
    gapHeadOfficeId: null,
};
const getters = {
    isGapModeOn: (state) => {
        return !!Number(state.gapMode);
    },
    getGapHeadOfficeId: (state) => {
        return state.gapHeadOfficeId;
    },
};

const mutations = {
    SET_GAP_MODE(state, value) {
        state.gapMode = value;
    },
    SET_GAP_HEAD_OFFICE_ID(state, value) {
        state.gapHeadOfficeId = value;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
};
